import React from "react";
import { ErrorText } from "..";

export const TextAreaInput = props => {
    const {
        value,
        onChange,
        disabled,
        name,
        isError,
        errorText
    } = props;
    return (
        <>
            <textarea
                value={value}
                onChange={onChange}
                className={isError ? 'errorTextArea' : 'textAreaCls'}
                disabled={disabled}
                
                name={name}
            />
            {isError &&
                <div>
                    <ErrorText text={errorText}/>
                </div>
            }
        </>
    );
};

export default TextAreaInput;